import React from 'react'

function IndustrySec() {
    return (
        <>
            <section className="counts section-bg" id="industry">
                <div className="container">
                    <div className="section-title">
                        <h2>Industry We Serve</h2>

                    </div>

                    <div className="row">

                        <div className="col-lg-4 col-md-6 col-sm-6 text-center" data-aos="fade-up">
                        <a href="/education-and-training">
                        <div className="count-box">
                                <i className="icofont-education" styles="color:#63be63;"></i>
                                <h5 className="title">Education &amp; <br/>Training</h5>
                            </div>
                            </a>
                        </div>

                        <div className="col-lg-4 col-md-6 col-sm-6 text-center" data-aos="fade-up" data-aos-delay="200">
                        <a href="/entertainment-and-event-management">
                        <div className="count-box">
                                <i className="icofont-ui-calendar" styles="color: #63be63;"></i>
                                <h5 className="title">Entertainment &amp; <br/>Event Management</h5>
                            </div>
                            </a>
                        </div>

                        <div className="col-lg-4 col-md-6 col-sm-6 text-center" data-aos="fade-up" data-aos-delay="400">
                        <a href="/healthcare-and-fitness">
                        <div className="count-box">
                                <i className="icofont-doctor" styles="color: #63be63;"></i>
                                <h5 className="title">Healthcare &amp; <br/>Fitness</h5>
                            </div>
                            </a>
                        </div>

                        <div className="col-lg-4 col-md-6 col-sm-6 text-center" data-aos="fade-up" data-aos-delay="600">
                        <a href="/real-estate-services">
                        <div className="count-box">
                                <i className="icofont-home" styles="color: #63be63;"></i>
                                <h5 className="title">Real <br/>Estate</h5>
                            </div>
                            </a>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-6 text-center" data-aos="fade-up" data-aos-delay="800">
                        <a href="/retail-and-ecommerce">
                        <div className="count-box">
                                <i className="icofont-shopping-cart" styles="color: #63be63;"></i>
                                <h5 className="title">Retail &amp; <br/>Ecommerce</h5>
                            </div>
                            </a>
                        </div>

                        <div className="col-lg-4 col-md-6 col-sm-6 text-center" data-aos="fade-up" data-aos-delay="1000">
                        <a href="/sales-and-marketing">
                        <div className="count-box">
                                <i className="icofont-chart-histogram" styles="color:#63be63;"></i>
                                <h5 className="title">Sales &amp; <br/>Marketing</h5>
                            </div>
                            </a>
                        </div>

                        <div className="col-lg-4 col-md-6 col-sm-6 text-center" data-aos="fade-up" data-aos-delay="1200">
                        <a href="/staffing-recruitment-service">
                        <div className="count-box">
                                <i className="icofont-users-alt-5" styles="color: #63be63;"></i>
                                <h5 className="title">Staffing &amp; <br/>Recruitment</h5>
                            </div>
                            </a>
                        </div>

                        <div className="col-lg-4 col-md-6 col-sm-6 text-center" data-aos="fade-up" data-aos-delay="1400">
                        <a href="/travel-vacation-rentals-service">
                        <div className="count-box">
                                <i className="icofont-travelling" styles="color: #63be63;"></i>
                                <h5 className="title">Travel &amp; <br/>Vacation Rentals</h5>
                            </div>
                            </a>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-6 text-center" data-aos="fade-up" data-aos-delay="1600">
                        <a href="/customerServices">
                            <div className="count-box ">
                                <i className="icofont-search-user" styles="color: #63be63;"></i>
                                <h5 className="title" >Customer <br/>Services</h5>
                            </div>
                            </a>
                        </div>

                    </div>

                </div>
            </section>
        </>
    )
}

export default IndustrySec
